// extracted by mini-css-extract-plugin
export default {"subscription_item_price":"tA","delete_item":"uA","subscription_item":"vA","subscription_item_img_wrapper":"wA","subscription_item_info":"xA","subscription_item_title":"yA","subscription_item_edit":"zA","subscription_item_wrapper":"AA","arrow":"BA","subscription_item_category":"CA","plus_button":"EA","more_details":"FA","old_price":"GA","discount":"HA"};
    if(module.hot) {
      // 1714422956059
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  